'use client'

import { useMemo } from 'react'
import { useSearchParams } from '@/hooks/useSearchParams'

const normalizeSlug = (value: string | null) => {
  if (!value) {
    return null
  }
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function useFlowOverride() {
  const search = useSearchParams()

  return useMemo(() => {
    if (!search) {
      return { flowId: null, flowSlug: null }
    }

    const params = new URLSearchParams(search)
    const rawId = params.get('_flowId')
    const rawSlug = params.get('_flowSlug') ?? params.get('_flowSlug')

    const parsedId = rawId ? Number.parseInt(rawId, 10) : NaN
    const flowId = Number.isFinite(parsedId) && parsedId > 0 ? parsedId : null
    const flowSlug = normalizeSlug(rawSlug)

    return { flowId, flowSlug }
  }, [search])
}
